module.exports = __webpack_public_path__ + "static/media/supermarket-2.3fce1365.png";